// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__hSjhZ","breathing":"styles_breathing__e_Mrt"};